import React from "react";

export default class LoginService extends React.Component {

	userLogin(user) {
	    let myHeaders = new Headers();
    	myHeaders.append("X-GPA-ORIGIN", "e-commerce");
    	myHeaders.append("Content-Type", "application/json;charset=UTF-8");
    	var response = {error: null};

        response = fetch('https://api.gpa.digital/pa/v2/user/login', {
	        method: 'POST',
	        headers: myHeaders,
	        mode: 'cors',
	        body: JSON.stringify(user)
	    }).then((response) => {
	        return response.json().then(data => {
	        	if(data.status == "success" || data.status == 200){
	        		localStorage.logged = true;
					localStorage.username = data.content.customerFirstName;
					localStorage.loginMais = true;
					window.dataLayer.push({
						"event" : "login",
						"pagePath" : window.location.pathname,
						"id_login" : "LoginMaisEfetuado"
					});
					saveUserTokenCookie(data.content);
	        	}else if (data.status == 400 || data.status == 401) {
		            return {error: "Usuário ou senha incorreto(s)!"};
		        } else {
		            return {error: "Ocorreu um erro ao realizar o login, tente novamente mais tarde!"};
		        }
		    });
	    }).catch(() => {
	        return {error: "Ocorreu um erro ao realizar o login, tente novamente mais tarde!"};
	    });

	    const saveUserTokenCookie = function(data) {
		    let expireDate = calcExpiresDate(data.expires_in);
		    let tokens = {
		        token_type: data.token_type,
		        access_token: data.access_token,
		        refresh_token: data.refresh_token,
		        expires_in: data.expires_in
		    };
		    
		    document.cookie = "USER_TOKENS="+ encodeURIComponent(JSON.stringify(tokens)) +";" + "expires=" + expireDate + ";path=/";
		    getClient(data);
		};

		const saveDataUserCookie = function(expiresIn, client){
			let expireDate = calcExpiresDate(expiresIn);
            let clientData = {
                'ep.customer_id': client.id,
                'ep.customer_name': client.fantasyName || client.firstName,
                'ep.first_name': client.firstName,
                'ep.customer_cpf': client.cpf,
                'bpartner': client.bpartner,
                'email': client.email
            };

            document.cookie = "USER_DATA="+ encodeURIComponent(JSON.stringify(clientData)) +";" + "expires=" + expireDate + ";path=/";
            window.location.href = "/mais?login=mais";
            location.reload();
		};

		const calcExpiresDate = function(expiresIn) {
		    let date = new Date();
		    let utcEpochSeconds = date.getTime();
		    let expiresInMiliSeconds = expiresIn * 1000;
		    let expirationTimestamp = utcEpochSeconds + expiresInMiliSeconds;

		    return new Date(expirationTimestamp);
		};

		const getClient = function(tokens){
			let tokenExpires = tokens.expires_in;
			let myHeaders = new Headers();
			let token = tokens.token_type + " " + tokens.access_token;

    		myHeaders.append("X-GPA-ORIGIN", "e-commerce");
    		myHeaders.append("Authorization", token);

			fetch('https://api.gpa.digital/pa/client', {
		        method: 'GET',
		        headers: myHeaders,
		        mode: 'cors'
		    }).then((response) => {
		        response.json().then(data => {
			        saveDataUserCookie(tokenExpires, data.content);
			    });
		    }).catch((error) => {
		    	console.log("Deu ruim!!!");
		    });
		};

		return response;
	};
}


// WEBPACK FOOTER //
// ./src/components/LoginService.js